import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import 'bridge/mock';

import { syncViewportHeightVar } from 'helpers/syncViewportHeightVar';

import { ArticleModule } from 'pages/articles/ArticleModule';
import { FakeDoorModule } from 'pages/fake-doors/FakeDoorModule';

import 'theme/applyTheme';

import { QueryProvider } from './providers/QueryProvider';

import 'styles/global.scss';

syncViewportHeightVar();

const router = createBrowserRouter([
    { path: '/', element: <div>Placeholder page</div> },
    { path: '/articles/:articleId', element: <ArticleModule /> },
    { path: '/fake-doors/:featureId', element: <FakeDoorModule /> },
]);

createRoot(document.getElementById('root') as HTMLElement).render(
    <QueryProvider>
        <RouterProvider router={router} />
    </QueryProvider>
);
